import {Button, Text} from "@wakelet/ui-kit";
import {Page} from "./Page";
import {translateKey} from "../components/language/translate";
import {getWakeletUrl} from "../env/env";

export const NotFoundPage = () => {
  return <Page showHeader>
    <img src="https://assets.wakelet.com/monomer/404.svg" alt={translateKey("common:site.pageNotFoundTitle")}/>
    <div className="flex flex-col items-center">
      <Text className="p-5">{translateKey("common:error.pageNotFound")}</Text>
      <Button.Style>
        <a href={getWakeletUrl()}>
          <Button.Label text={translateKey("common:buttons.backToWakelet")}/>
        </a>
      </Button.Style>
    </div>
  </Page>;
};
